// extracted by mini-css-extract-plugin
module.exports = {"NavItem":"NavItem_NavItem__24Omk","active":"NavItem_active__pqjP0"};